<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="additional"
      :items="additional"
      :fields="additionalFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
      <editModal :editItem="selectedAdditional"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      additionalFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'display_name', label: this.$i18n.t('Displayed name'), sortable: true},
        {key: 'settingsAdditionalVisible', label: this.$i18n.t('Visible'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedAdditional: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedAdditional = {
        id: 0,
        name: '',
        display_name: '',
        visible: false
      }
      this.$root.$emit('bv::show::modal', 'modalEditAdditionalParameter', '#btnShow')
    },
    editItem (item) {
      this.selectedAdditional = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditAdditionalParameter', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Additional parameter"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_ADDITIONAL', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_ADDITIONAL')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    additional () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/ADDITIONAL']))
      for (let el of copy) {
        if (el.visible) {
          el.settingsAdditionalVisible = true
        } else {
          el.settingsAdditionalVisible = false
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_ADDITIONAL')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/system/additional/main.vue